import NotFoundPage from "pages/NotFoundPage";
import React from "react";

const NotFoundRoute = () => <NotFoundPage />;

export default NotFoundRoute;
